/**
 * نظام التخزين المؤقت للبيانات
 * يحسن أداء التطبيق بتقليل طلبات API المتكررة
 */

// مدة صلاحية الكاش بالملي ثانية
const CACHE_DURATIONS = {
  branches: 10 * 60 * 1000,      // 10 دقائق - نادراً ما تتغير
  departments: 10 * 60 * 1000,   // 10 دقائق
  employees: 5 * 60 * 1000,      // 5 دقائق
  user: 5 * 60 * 1000,           // 5 دقائق
  notifications: 1 * 60 * 1000,  // دقيقة واحدة
  tasks: 2 * 60 * 1000,          // دقيقتين
  leaves: 2 * 60 * 1000,         // دقيقتين
  duties: 2 * 60 * 1000,         // دقيقتين
  default: 3 * 60 * 1000         // 3 دقائق افتراضي
};

// التخزين المؤقت
const cache = new Map();

/**
 * الحصول على بيانات من الكاش
 */
export const getCachedData = (key) => {
  const cached = cache.get(key);
  if (!cached) return null;
  
  const { data, timestamp, duration } = cached;
  const now = Date.now();
  
  // التحقق من انتهاء الصلاحية
  if (now - timestamp > duration) {
    cache.delete(key);
    return null;
  }
  
  return data;
};

/**
 * حفظ بيانات في الكاش
 */
export const setCachedData = (key, data, customDuration = null) => {
  const duration = customDuration || CACHE_DURATIONS[key] || CACHE_DURATIONS.default;
  cache.set(key, {
    data,
    timestamp: Date.now(),
    duration
  });
};

/**
 * حذف بيانات من الكاش
 */
export const clearCache = (key = null) => {
  if (key) {
    cache.delete(key);
  } else {
    cache.clear();
  }
};

/**
 * حذف كاش مرتبط بنوع معين (مثل: كل كاش المهام)
 */
export const clearCacheByPrefix = (prefix) => {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) {
      cache.delete(key);
    }
  }
};

/**
 * دالة مساعدة لجلب البيانات مع الكاش
 */
export const fetchWithCache = async (key, fetchFunction, forceRefresh = false) => {
  // إذا لم يكن هناك إجبار على التحديث، نحاول الكاش أولاً
  if (!forceRefresh) {
    const cached = getCachedData(key);
    if (cached) {
      console.log(`📦 Cache hit: ${key}`);
      return cached;
    }
  }
  
  // جلب البيانات من الـ API
  console.log(`🌐 Fetching: ${key}`);
  const data = await fetchFunction();
  
  // حفظ في الكاش
  setCachedData(key, data);
  
  return data;
};

/**
 * مسح الكاش عند تسجيل الخروج
 */
export const clearAllCacheOnLogout = () => {
  cache.clear();
  console.log('🗑️ Cache cleared on logout');
};

export default {
  getCachedData,
  setCachedData,
  clearCache,
  clearCacheByPrefix,
  fetchWithCache,
  clearAllCacheOnLogout
};
